module.exports = __webpack_public_path__ + "static/DSC_9439-53510f23cf0d61a6b1300dd9666a306e.jpg";